// extracted by mini-css-extract-plugin
module.exports =  {"predicate":"ieIoq4e7ZC4q1v9f6ArY"};